export type ApprovalOddsResponseObject = {
  id: string;
  approvalLikelihood: string;
  score: number;
};

export type ApprovalOddsResponse = Record<string, ApprovalOddsResponseObject>;

export enum Likelihood {
  Poor = 'Poor',
  Fair = 'Fair',
  Good = 'Good',
  Excellent = 'Excellent',
}

export type ApprovalOddsValues = {
  label: Likelihood | null;
  labelDelta: number;
  desktopDelta: number;
  color: string;
  placement: number;
};

const POOR_RANGE = {
  min: 300,
  max: 629,
};

const FAIR_RANGE = {
  min: 630,
  max: 689,
};

const GOOD_RANGE = {
  min: 690,
  max: 719,
};

const EXCELLENT_RANGE = {
  min: 720,
  max: 850,
};

export { EXCELLENT_RANGE, FAIR_RANGE, GOOD_RANGE, POOR_RANGE };

export const CREDIT_RANGES = [POOR_RANGE, FAIR_RANGE, GOOD_RANGE, EXCELLENT_RANGE];

export const CTA_LABEL = 'Get your free credit score';

export const ENTITY_NAME = 'cc_get_approval_odds';
export const SECTION_NAME = 'roundup_recommendations';

export const AO_RANGES = {
  LOW: {
    min: 0,
    max: 0.45,
  },
  MEDIUM: {
    min: 0.45,
    max: 0.65,
  },
  HIGH: {
    min: 0.65,
    max: 1,
  },
};

export const RECOMMENDED_CREDIT_TOOLTIP_TEXT =
  "Based on NerdWallet’s analysis a credit score in or above the recommended range means you have a higher chance of approval, but doesn't guarantee it. Use this link to create an account and connect your credit score with TransUnion.";

export const RECOMMENDED_CREDIT_LEARN_MORE_PATH =
  'credit-cards/learn/good-credit-still-rejected-for-card';
